import { useState } from "react";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";
import { api, errMsg } from "../../lib/api";

export function Lexicon({ items, onChanged }) {
  const [f, setF] = useState({ wrong: "", right: "" });
  const add = async () => {
    try { await api.post("/pm/lexicon", f); setF({ wrong: "", right: "" }); onChanged(); } catch (e) { toast.error(errMsg(e)); }
  };
  const del = async (id) => { await api.delete(`/pm/lexicon/${id}`); onChanged(); };
  return (
    <div className="space-y-3" data-testid="pm-lexicon">
      <p className="text-sm text-slate-600">Corrections validées proposées pendant la saisie. Elles n'écrasent jamais la transcription d'origine.</p>
      <table className="tl-table text-sm">
        <thead><tr><th>Texte lu</th><th>Correction validée</th><th>Par</th><th /></tr></thead>
        <tbody>{items.map((x) => (
          <tr key={x.id} data-testid={`lexicon-${x.wrong}`}><td className="tl-mono">{x.wrong}</td><td>{x.right}</td><td className="text-xs">{x.created_by}</td>
            <td><button className="tl-btn tl-btn-ghost tl-btn-sm" onClick={() => del(x.id)} aria-label="Supprimer" data-testid={`lexicon-delete-${x.id}`}><Trash2 size={14} /></button></td></tr>
        ))}</tbody>
      </table>
      <div className="grid sm:grid-cols-[1fr_2fr_auto] gap-2">
        <input className="tl-input" placeholder="Texte lu (ex. MANIAGE)" value={f.wrong} onChange={(e) => setF({ ...f, wrong: e.target.value })} data-testid="lexicon-wrong" />
        <input className="tl-input" placeholder="Correction validée" value={f.right} onChange={(e) => setF({ ...f, right: e.target.value })} data-testid="lexicon-right" />
        <button className="tl-btn tl-btn-dark" onClick={add} data-testid="lexicon-add"><Plus size={14} /> Ajouter</button>
      </div>
    </div>
  );
}
